// extracted by mini-css-extract-plugin
export var columnTitle = "footer-module--columnTitle--23d6b";
export var contactContent = "footer-module--contactContent--40b89";
export var copyright = "footer-module--copyright--b8660";
export var footerCompanyImages = "footer-module--footerCompanyImages--a024d";
export var formContent = "footer-module--formContent--f3982";
export var hasSubmenu = "footer-module--hasSubmenu--5d829";
export var menuItem = "footer-module--menuItem--b2421";
export var navContent = "footer-module--navContent--4dfc4";
export var navigationColumn = "footer-module--navigationColumn--6d188";
export var opened = "footer-module--opened--d7898";
export var socialWrapper = "footer-module--socialWrapper--94961";